import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { OneTimePaySetup } from '@amfam/billing/one-time-pay/feature';

@Component({
  selector: 'amfam-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AccountListComponent {
  @Input() options: OneTimePaySetup[];
  @Input() parentFormGroup: UntypedFormGroup;
  @Input() showAutoPaySetUpLink: boolean;
  @Input() linkText: string;
  @Output() setupAutopayEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() editEvent = new EventEmitter();
  @Output() deleteEvent = new EventEmitter();

  constructor() {}

  setupAutopay() {
    this.setupAutopayEvent.emit();
  }
  edit(id: string | number) {
    this.editEvent.emit(id);
  }
  delete(id: string | number) {
    this.deleteEvent.emit(id);
  }
}
